import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal} from "antd";
import {t} from "i18next";
import {isStringNullOrEmpty} from "../../utils";
import {
    GET_ARRAY_LIBRARY_TYPES,
    IMPORT_FILE_MODE_IMPORTMODE,
    KEY_TYPE_SWITCHER,
    MENU_SEPARATOR
} from "../../Const";
import {ipcInvoke} from "../../common/ipc";

const DialogTypeSwitcherSetting = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const mCallbackRef = useRef(null);

    const ARRAY_DEFAULT_TYPE_SWITCHER = [
        {
            value:'all',
            label:t("All"),
            isSelected:true
        },
        {
            value:'card',
            label:t("Card"),
            buttonLabel:t("New card"),
            icon:'library_type_card'
        },
        {
            value:'journal',
            label:t("Journal"),
            buttonLabel:t("New journal"),
            icon:'library_type_journal'
        },
        {
            value:'pdf',
            label:t("PDF"),
            buttonLabel:t("New PDF"),
            ext:'.pdf',
            icon:'library_type_pdf'
        },
        {
            value:'image',
            label:t("Image"),
            buttonLabel:t("New image"),
            ext:'.jpg,.jpeg,.bmp,.png',
            icon:'library_type_image'
        },
        {
            value:'video',
            label:t("Video"),
            buttonLabel:t("New video"),
            ext:'.mp4,.mov',
            icon:'library_type_video'
        },
    ]


    const [arrayLibraryTypes,setArrayLibraryTypes] = useState(GET_ARRAY_LIBRARY_TYPES);

    useEffect(()=>{
        const szTypeSwitcher = localStorage.getItem(KEY_TYPE_SWITCHER);
        let jsonSelected = ARRAY_DEFAULT_TYPE_SWITCHER;
        if (szTypeSwitcher){
            jsonSelected = JSON.parse(szTypeSwitcher);
        }

        const arrayNewLibraryTypes = [...arrayLibraryTypes];
        for (let i=0;i<arrayNewLibraryTypes.length;i++){
            const item = arrayNewLibraryTypes[i];
            if (jsonSelected.some(p=>p.value == item.value)){
                item.isSelected = true;
            }else{
                item.isSelected = false;
            }
        }
        setArrayLibraryTypes(arrayNewLibraryTypes);
    },[])

    const onShowDialog = (callback:any)=>{
        setIsShowDialog(true);
        mCallbackRef.current = callback;
    }

    return <Modal width={468} zIndex={2005}
                  afterClose={() => {
                      props.onCloseCallback();
                  }}
                  open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }}>
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                <span className={'dialog-title'}>{t("TypeSwitcherSetting")}</span>
                <div style={{flexGrow: '1'}}/>
            </div>
            <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>

            <span className={'dialog-title'}>{t("Visible types")}</span>
            <span style={{color:'var(--color-666666)',marginTop:'10px',fontSize:'12px'}}>{t("SelectUp6Type")}</span>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginTop:'16px'}}>
                {
                    arrayLibraryTypes.map(p=>{
                        return(<div className={'flex-row-vertical-center cursor-pointer'} style={{borderRadius:'8px',
                            border:p.isSelected?'1px solid var(--primary-color)':'1px solid var(--border-color)',
                            background:p.isSelected?'#3670F71A':'transparent',
                            height:'44px',padding:'0 10px'}} onClick={()=>{
                                const arrayNewLibrarys = [...arrayLibraryTypes];
                                if (p.isSelected) {
                                    //取消选中
                                    p.isSelected = false;
                                    setArrayLibraryTypes(arrayNewLibrarys);
                                }else {
                                    const nCount = arrayNewLibrarys.filter(p => p.isSelected).length;
                                    if (nCount < 5) {
                                        p.isSelected = true;
                                        setArrayLibraryTypes(arrayNewLibrarys);
                                    }else {
                                        message.destroy();
                                        message.error(t('Maximum5Allowed'));
                                    }
                                }
                        }}>
                            <Checkbox checked={p.isSelected}/>
                            <span className={'ml-10'}>{p.label}</span>
                        </div>)
                    })
                }
            </div>


            <div className={'flex-row-vertical-center mt-32 mb-4'} style={{alignSelf:'flex-end'}}>
                <Button
                    style={{height: '34px', minWidth: '80px'}}
                    className='large-w-button button-border-gray-style font-size-14 font-family-medium'
                    onClick={() => {
                        setIsShowDialog(false);
                    }}>{t("Cancel")}</Button>
                <Button
                    // disabled={isStringNullOrEmpty(selectFile)}
                    className='large-w-button button-solid-style font-size-14 font-family-medium'
                    type="primary"
                    onClick={async () => {
                        props.onCloseCallback();
                        //保存选择的..
                        const arraySelected = arrayLibraryTypes.filter(p=>p.isSelected);
                        mCallbackRef?.current(arraySelected);
                    }}
                    style={{
                        marginLeft: '12px',
                        minWidth: '120px'
                    }}>{t("Save changes")}</Button>
            </div>
        </div>
    </Modal>
})

export default DialogTypeSwitcherSetting;






































